import script from "./ClassesBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassesBlock.vue?vue&type=script&setup=true&lang=js"

import "./ClassesBlock.vue?vue&type=style&index=0&id=0860a7d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0860a7d0"]])

export default __exports__